/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Auth0Plugin } from "./auth0-plugin";
import GmapVue from 'gmap-vue'

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyC91bewO2sbv-TRzjEp9aAsnrV9up4sagc',
    libraries: ["places", "visualization"], // This is required if you use the Autocomplete plugin
  },
  installComponents: true,
  
})

// import validations from "@/mixins/validations";
// Vue.mixin(validations)

import './plugins/index'

import CardLoadingTransparent from "./components/shared/CardLoadingTransparent";
import CardLoading from "./components/shared/CardLoading";
import DialogLoading from "./components/shared/DialogLoading";
import DefaultDialog from "@/_backoffice/_registrations/components/shared/DefaultDialog";
import DefaultBtn from "@/components/shared/defaultBtn.vue"

Vue.component("dialog-loading", DialogLoading);
Vue.component("card-loading", CardLoading);
Vue.component("card-loading-transparent", CardLoadingTransparent);
Vue.component("default-dialog", DefaultDialog);
Vue.component("f-btn", DefaultBtn)

import current_user from "./mixins/current_user";
import current_modality from "./mixins/current_modality";
import swall from "./mixins/swall"
import notification from "./mixins/notification"
Vue.mixin(current_user)
Vue.mixin(current_modality)
Vue.mixin(swall)
Vue.mixin(notification)

Vue.config.productionTip = false;

const DocumentPersonBrFilter = {
  install(Vue, options) {
    Vue.filter('DocumentPersonBr', (doc, kind) => {
      if (doc){
        doc = typeof doc != 'string' ? doc.toString() : doc;
        if (kind == 'CNPJ') {
          doc = doc.padStart(14, '0');
          doc = doc.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else {
          doc = doc.padStart(11, '0');
          doc = doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
      }
      return doc;
    });
  },
};
Vue.use(DocumentPersonBrFilter);



Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetPath
        ? appState.targetPath
        : window.location.pathname
    );
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
/* eslint-enable */
